// Mobile menu
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.mobile-nav-toggle');
  const menu = document.querySelector('.mobile-menu');
  const close = document.querySelector('.mobile-menu__close');
  const backdrop = document.querySelector('.mobile-menu__backdrop');

  if (toggle && menu) {
    toggle.addEventListener('click', () => menu.classList.add('is-open'));
    if (close) close.addEventListener('click', () => menu.classList.remove('is-open'));
    if (backdrop) backdrop.addEventListener('click', () => menu.classList.remove('is-open'));
  }

  // Quantity controls
  document.querySelectorAll('.qty-control').forEach(ctrl => {
    const minus = ctrl.querySelector('[data-action="minus"]');
    const plus = ctrl.querySelector('[data-action="plus"]');
    const val = ctrl.querySelector('.qty-control__value');
    const input = ctrl.closest('form')?.querySelector('input[name="quantity"]');

    function update(n) {
      val.textContent = n;
      if (input) input.value = n;
    }

    if (minus) minus.addEventListener('click', () => {
      const n = Math.max(1, parseInt(val.textContent) - 1);
      update(n);
    });
    if (plus) plus.addEventListener('click', () => {
      const n = parseInt(val.textContent) + 1;
      update(n);
    });
  });
});
